import {useQuery} from "@tanstack/react-query";
import _ from "lodash";
import {getAllFields} from "../services/fieldService";
import {OrderStatus} from "../types/domain/orderStatus";

export const useActiveCompanyFields = (companyId?: string, activeFields?: boolean) => {
    return useQuery({
        queryKey: ["companyFields", companyId, activeFields],
        queryFn: async () => {
            if (!companyId) return {fields: [], mapByFarmId: {}, mapByOrderId: {}, mapByFieldId: {}};

            let allFields = await getAllFields({companyId});

            if (activeFields) {
                allFields = allFields.filter((item) => item.order?.state === OrderStatus.ACTIVE);
            }

            return {
                fields: allFields ?? [],
                mapByFarmId: _.groupBy(allFields, "farmId"),
                mapByOrderId: _.groupBy(allFields, "orderId"),
                mapByFieldId: _.keyBy(allFields, "id"),
            };
        },
        enabled: !!companyId,
    });
};
